//Saga
import { put, takeEvery, call, all } from "redux-saga/effects";

import {
  GET_TIME_ENTRIES_LIST,
  TIME_ENTRY_LIST_OPEN,
  TIME_ENTRY_START,
  TIME_ENTRY_STOP,
  TIME_ENTRY_SEARCH_BY_STAFF_ID,
  GET_TIME_ENTRY_TYPE_LIST,
  TIME_ENTRY_SINGLE_ENTRY_UPDATE,
  TIME_ENTRY_SEARCH_WITH_TODAYS_DATE,
  ADD_NEW_TIME_ENTRY_NON_BILLABLE_TYPE,
  DELETE_TIME_ENTRY_NON_BILLABLE_TYPE,
  UPDATE_TIME_ENTRY_NON_BILLABLE_TYPE,
  DELETE_SELECTED_TIME_ENTRIES,
  TIME_ENTRY_LIST_SUMMARY_DAILY,
  TIME_ENTRY_CREATE,
  TIME_ENTRY_LIST_SUMMARY_DAILY_BY_ACTIVITY,
} from "./actionType";

import {
  getTimeEntriesListSuccess,
  getTimeEntriesListFailure,
  timeEntryListOpenSuccess,
  timeEntryListOpenFailure,
  timeEntryStartSuccess,
  timeEntryStartFailure,
  timeEntryStopSuccess,
  timeEntryStopFailure,
  timeEntrySearchByStaffIdSuccess,
  timeEntrySearchByStaffIdFailure,
  getTimeEntryTypeListSuccess,
  getTimeEntryTypeListFailure,
  timeEntrySingleEntryUpdateSuccess,
  timeEntrySingleEntryUpdateFailure,
  timeEntrySearchWithTodaysDateSuccess,
  timeEntrySearchWithTodaysDateFailure,
  addNewTimeEntryNonBillableTypeSuccess,
  addNewTimeEntryNonBillableTypeFailure,
  deleteTimeEntryNonBillableTypeSuccess,
  deleteTimeEntryNonBillableTypeFailure,
  updateTimeEntryNonBillableTypeSuccess,
  updateTimeEntryNonBillableTypeFailure,
  deleteSelectedTimeEntriesSuccess,
  deleteSelectedTimeEntriesFailure,
  timeEntryListSummaryDailySuccess,
  timeEntryListSummaryDailyFailure,
  timeEntryCreateSuccess,
  timeEntryCreateFailure,
  timeEntryListSummaryDailyByActivitySuccess,
  timeEntryListSummaryDailyByActivityFailure,
} from "./action";

import {
  getTimeEntryListApiCall,
  postTimeEntryListOpenApiCall,
  postTimeEntryStartApiCall,
  postTimeEntryStopApiCall,
  postTimeEntrySearchByStaffIdApiCall,
  getTimeEntryTypeListApiCall,
  postTimeEntriesUpdateSingleTimeEntryApiCall,
  postTimeEntrySearchWithTodaysDateApiCall,
  postAddNewTimeEntryNonBillableTypeApiCall,
  postDeleteTimeEntryNonBillableTypeApiCall,
  postUpdateTimeEntryNonBillableTypeApiCall,
  postDeleteSelectedTimeEntriesApiCall,
  timeEntryListSummaryDailyApiCall,
  postTimeEntryCreateApiCall,
  timeEntryListSummaryDailyByActivityApiCall,
} from "../../helpers/fakebackend_helper";

// Saga Functions
function* getTimeEntriesListSaga(action) {
  try {
    const response = yield call(getTimeEntryListApiCall);
    yield put(getTimeEntriesListSuccess(response));
  } catch (error) {
    yield put(getTimeEntriesListFailure(error));
  }
}

function* watchGetTimeEntriesListSaga() {
  yield takeEvery(GET_TIME_ENTRIES_LIST, getTimeEntriesListSaga);
}

function* timeEntryListOpenSaga(action) {
  try {
    const response = yield call(postTimeEntryListOpenApiCall, action.payload);
    yield put(timeEntryListOpenSuccess(response));
  } catch (error) {
    yield put(timeEntryListOpenFailure(error));
  }
}

function* watchTimeEntryListOpenSaga() {
  yield takeEvery(TIME_ENTRY_LIST_OPEN, timeEntryListOpenSaga);
}

function* timeEntryStartSaga(action) {
  try {
    const response = yield call(postTimeEntryStartApiCall, action.payload);
    yield put(timeEntryStartSuccess(response));
  } catch (error) {
    yield put(timeEntryStartFailure(error));
  }
}

function* watchTimeEntryStartSaga() {
  yield takeEvery(TIME_ENTRY_START, timeEntryStartSaga);
}

function* timeEntryStopSaga(action) {
  try {
    const response = yield call(postTimeEntryStopApiCall, action.payload);
    yield put(timeEntryStopSuccess(response));
  } catch (error) {
    yield put(timeEntryStopFailure(error));
  }
}

function* watchTimeEntryStopSaga() {
  yield takeEvery(TIME_ENTRY_STOP, timeEntryStopSaga);
}

function* timeEntrySearchByStaffIdSaga(action) {
  try {
    const response = yield call(
      postTimeEntrySearchByStaffIdApiCall,
      action.payload
    );
    yield put(timeEntrySearchByStaffIdSuccess(response));
  } catch (error) {
    yield put(timeEntrySearchByStaffIdFailure(error));
  }
}

function* watchTimeEntrySearchByStaffIdSaga() {
  yield takeEvery(TIME_ENTRY_SEARCH_BY_STAFF_ID, timeEntrySearchByStaffIdSaga);
}

function* getTimeEntryTypeListSaga() {
  try {
    const response = yield call(getTimeEntryTypeListApiCall);
    yield put(getTimeEntryTypeListSuccess(response));
  } catch (error) {
    yield put(getTimeEntryTypeListFailure(error));
  }
}

function* watchGetTimeEntryTypeListSaga() {
  yield takeEvery(GET_TIME_ENTRY_TYPE_LIST, getTimeEntryTypeListSaga);
}

function* timeEntrySingleEntryUpdateSaga(action) {
  try {
    const response = yield call(
      postTimeEntriesUpdateSingleTimeEntryApiCall,
      action.payload
    );
    yield put(timeEntrySingleEntryUpdateSuccess(response));
  } catch (error) {
    yield put(timeEntrySingleEntryUpdateFailure(error));
  }
}

function* watchTimeEntrySingleEntryUpdateSaga() {
  yield takeEvery(
    TIME_ENTRY_SINGLE_ENTRY_UPDATE,
    timeEntrySingleEntryUpdateSaga
  );
}

// Time Entry Search With Todays Date
function* timeEntrySearchWithTodaysDateSaga(action) {
  try {
    const response = yield call(
      postTimeEntrySearchWithTodaysDateApiCall,
      action.payload
    );
    yield put(timeEntrySearchWithTodaysDateSuccess(response));
  } catch (error) {
    yield put(timeEntrySearchWithTodaysDateFailure(error));
  }
}

function* watchTimeEntrySearchWithTodaysDateSaga() {
  yield takeEvery(
    TIME_ENTRY_SEARCH_WITH_TODAYS_DATE,
    timeEntrySearchWithTodaysDateSaga
  );
}

// Add New Time Entry Non Billable Type
function* addNewTimeEntryNonBillableTypeSaga(action) {
  try {
    const response = yield call(
      postAddNewTimeEntryNonBillableTypeApiCall,
      action.payload
    );
    yield put(addNewTimeEntryNonBillableTypeSuccess(response));
  } catch (error) {
    yield put(addNewTimeEntryNonBillableTypeFailure(error));
  }
}

function* watchAddNewTimeEntryNonBillableTypeSaga() {
  yield takeEvery(
    ADD_NEW_TIME_ENTRY_NON_BILLABLE_TYPE,
    addNewTimeEntryNonBillableTypeSaga
  );
}

// Delete Time Entry Non Billable Type
function* deleteTimeEntryNonBillableTypeSaga(action) {
  try {
    const response = yield call(
      postDeleteTimeEntryNonBillableTypeApiCall,
      action.payload
    );
    yield put(deleteTimeEntryNonBillableTypeSuccess(response));
  } catch (error) {
    yield put(deleteTimeEntryNonBillableTypeFailure(error));
  }
}

function* watchDeleteTimeEntryNonBillableTypeSaga() {
  yield takeEvery(
    DELETE_TIME_ENTRY_NON_BILLABLE_TYPE,
    deleteTimeEntryNonBillableTypeSaga
  );
}

// Update Time Entry Non Billable Type
function* updateTimeEntryNonBillableTypeSaga(action) {
  try {
    const response = yield call(
      postUpdateTimeEntryNonBillableTypeApiCall,
      action.payload
    );
    yield put(updateTimeEntryNonBillableTypeSuccess(response));
  } catch (error) {
    yield put(updateTimeEntryNonBillableTypeFailure(error));
  }
}

function* watchUpdateTimeEntryNonBillableTypeSaga() {
  yield takeEvery(
    UPDATE_TIME_ENTRY_NON_BILLABLE_TYPE,
    updateTimeEntryNonBillableTypeSaga
  );
}

// Delete Selected Time Entries
function* deleteSelectedTimeEntriesSaga(action) {
  try {
    const response = yield call(
      postDeleteSelectedTimeEntriesApiCall,
      action.payload
    );
    yield put(deleteSelectedTimeEntriesSuccess(response));
  } catch (error) {
    yield put(deleteSelectedTimeEntriesFailure(error));
  }
}

function* watchDeleteSelectedTimeEntriesSaga() {
  yield takeEvery(DELETE_SELECTED_TIME_ENTRIES, deleteSelectedTimeEntriesSaga);
}
// Time Entry List Summary Daily
function* timeEntryListSummaryDailySaga(action) {
  try {
    const response = yield call(
      timeEntryListSummaryDailyApiCall,
      action.payload
    );
    yield put(timeEntryListSummaryDailySuccess(response));
  } catch (error) {
    yield put(timeEntryListSummaryDailyFailure(error));
  }
}
function* watchTimeEntryListSummaryDailySaga() {
  yield takeEvery(TIME_ENTRY_LIST_SUMMARY_DAILY, timeEntryListSummaryDailySaga);
}
// Time Entry Create
function* timeEntryCreateSaga(action) {
  try {
    const response = yield call(postTimeEntryCreateApiCall, action.payload);
    yield put(timeEntryCreateSuccess(response));
  } catch (error) {
    yield put(timeEntryCreateFailure(error));
  }
}

function* watchTimeEntryCreateSaga() {
  yield takeEvery(TIME_ENTRY_CREATE, timeEntryCreateSaga);
}

// Time Entry List Summary Daily By Activity
function* timeEntryListSummaryDailyByActivitySaga(action) {
  try {
    const response = yield call(
      timeEntryListSummaryDailyByActivityApiCall,
      action.payload
    );
    yield put(timeEntryListSummaryDailyByActivitySuccess(response));
  } catch (error) {
    yield put(timeEntryListSummaryDailyByActivityFailure(error));
  }
}

function* watchTimeEntryListSummaryDailyByActivitySaga() {
  yield takeEvery(
    TIME_ENTRY_LIST_SUMMARY_DAILY_BY_ACTIVITY,
    timeEntryListSummaryDailyByActivitySaga
  );
}

// Root Saga

export default function* TimeEntriesSaga() {
  yield all([
    watchGetTimeEntriesListSaga(),
    watchTimeEntryListOpenSaga(),
    watchTimeEntryStartSaga(),
    watchTimeEntryStopSaga(),
    watchTimeEntrySearchByStaffIdSaga(),
    watchGetTimeEntryTypeListSaga(),
    watchTimeEntrySingleEntryUpdateSaga(),
    watchTimeEntrySearchWithTodaysDateSaga(),
    watchAddNewTimeEntryNonBillableTypeSaga(),
    watchDeleteTimeEntryNonBillableTypeSaga(),
    watchUpdateTimeEntryNonBillableTypeSaga(),
    watchDeleteSelectedTimeEntriesSaga(),
    watchTimeEntryListSummaryDailySaga(),
    watchTimeEntryCreateSaga(),
    watchTimeEntryListSummaryDailyByActivitySaga(),
  ]);
}
